/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import get from "lodash/get";

import { Link, EagerLoadImages } from "@quintype/components";

import { AdContainer } from "../../ads";

import StoryCard1 from "../../molecules/story-card1";
import StoryCard2 from "../../molecules/story-card2";
import StoryCard3 from "../../molecules/story-card3";
import StoryCard4 from "../../molecules/story-card4";

import CardImage from "../../atoms/cardimage";
import { filterCollection, filterStory } from "../../helper/api";
import Separator from "../../atoms/separator";

import "./top-stories.m.css";
import Arrow from "../../atoms/other-icons/Arrow";

const TopStories = ({ collection, index }) => {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);
  const subashithaCollection = filterCollection(collection)[0];
  const subashithaStory = subashithaCollection && subashithaCollection.items[0] && subashithaCollection.items[0].story;

  if (!stories.length) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <div styleName="border-wrapper">
      <div styleName="wrapper">
        <div styleName="col-1">
          {stories?.splice(0, 1).map((item, index) => (
            <React.Fragment key={index}>
              <EagerLoadImages>
                <StoryCard1 story={item} />
              </EagerLoadImages>
            </React.Fragment>
          ))}
          <div styleName="col1-sub">
            <div styleName="col1-sub-stories sub1">
              {stories?.splice(0, 2).map((item, index) => (
                <StoryCard2 story={item} key={index} />
              ))}
            </div>
            <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} />
            <div styleName="col1-sub-stories sub2">
              {stories?.splice(0, 2).map((item, index) => (
                <StoryCard2 story={item} key={index} />
              ))}
            </div>
          </div>
        </div>
        <div styleName="col-2">
          {stories?.splice(0, 1).map((i, index) => (
            <StoryCard4 story={i} key={index} />
          ))}
          {stories?.splice(0, 2).map((i, index) => (
            <>
              <StoryCard3 story={i} key={index} />
              {index === 0 ? <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} /> : null}
            </>
          ))}
          {stories?.splice(0, 1).map((i, index) => (
            <StoryCard4 story={i} key={index} />
          ))}
          {stories?.splice(0, 2).map((i, index) => (
            <StoryCard3 story={i} key={index} />
          ))}
        </div>
        <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} />
        <div styleName="col-3">
          {!isMobile ? (
            <div styleName="ad-wrapper" className="hide-mobile">
              <AdContainer AdClassName="standard-300x250" id="div-gpt-ad-1680156228599-0" desktop="DH_Desktop_HP_RT" />
            </div>
          ) : null}
          {subashithaStory && (
            <div styleName="subashitha-card">
              <Link href={subashithaStory.url}>
                <CardImage story={subashithaStory} aspectRatio={[16, 9]} imageType="image16x9" showVideoIcon={true} />
              </Link>
            </div>
          )}
          {stories[0] && stories[0]?.sections[0] && (
            <Link styleName="seemore" href={`/news`}>
              See More
              <Arrow height="18px" width="18px" color="black" />
            </Link>
          )}
          {stories?.splice(0, 4).map((item, index) => (
            <StoryCard4 story={item} key={index} />
          ))}
        </div>
      </div>
      <Separator />
    </div>
  );
};

export default TopStories;
